import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo } from 'apollo-angular';
import { AdditionalTaskItemApiService } from '../additional-task-item-api.service';
import { IAdditionalTaskItem } from '../../../models/additionalTaskItem.interface';
import { ListAdditionalTaskItemQuery } from '../../../graphql/queries/additional-task-item.query';
import { TrainingApiService } from '../training-api.service';
import { ITraining } from '../../../models/training.interface';
import { GetListTrainingQuery } from '../../../graphql/queries/training.query';

@Injectable({
  providedIn: 'root'
})
export class TrainingGqlService
  implements TrainingApiService {
  constructor(private apollo: Apollo) {}

  public getList(trainingType:string): Observable<ITraining[]> {
    return this.apollo
      .query({
        query: GetListTrainingQuery,
        fetchPolicy: 'network-only',
        variables: { TrainingType: trainingType}
      })
      .pipe(
        map(result => {
          const results = result.data['trainings'] as ITraining[];

          return results;
        }),
        take(1)
      );
  }
}
